import { Buffer } from "/home/runner/work/vets-website/vets-website/node_modules/buffer/index.js";
export { Buffer };
